import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'distance',
  standalone: true,
})
export class DistancePipe implements PipeTransform {
  transform(meters: number | undefined | null): string {
    if (meters === null || meters === undefined) {
      return '';
    }
    if (meters < 1000) {
      return `${meters} m`;
    }
    const kilometers = meters / 1000;
    return `${kilometers.toFixed(1).replace('.', ',')} km`;
  }
}
